import type { PayloadAction } from '@reduxjs/toolkit';
import type { InternalUser } from '@ricoh/ria.client.core/model';

import type { InternalUserProfile } from '~/common/model/identity';

import type { InternalState } from './_state.type';

/** Internal Reducer. */
export const internalReducer = {
  /**
   * Internal setUser.
   *
   * @param {InternalState} state State.
   * @param {PayloadAction<InternalUser>} action Action.
   */
  internal_setUser: (state: InternalState, { payload }: PayloadAction<InternalUser>) => {
    state.internal.user = payload;
  },

  /**
   * Internal setProfile.
   *
   * @param {InternalState} state State.
   * @param {PayloadAction<InternalUserProfile | undefined>} action Action.
   */
  internal_setProfile: (state: InternalState, { payload }: PayloadAction<InternalUserProfile | undefined>) => {
    state.internal.profile = payload;
  },
};
